import React, {useState, useEffect} from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, Form, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
//import "jspdf-autotable";
import Select from 'react-select';
import { exportLedgerExcel } from "./ExportLedgerExcel";
import { exportLedgerPDF } from "./ExportLedgerPDF";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Ledger_Report = () => {

  const today = new Date().toISOString().split("T")[0];

  const [ddlSectionId, setDdlSectionId] = useState();
  const [paramAcct_Code, setParamAcct_Code] = useState();
  const [paramFromDate, setParamFromDate] = useState(today);
  const [paramToDate, setParamToDate] = useState(today);
  const [paramLedgerType, setParamLedgerType] = useState('G');
  const [paramZeroLed, setParamZeroLed] = useState('ZERO');

  const [societyName, setSocietyName] = useState();
  const [ledgerData, setLedgerData] = useState([]);
  const [acctCodes, setAcctCodes] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [ddlSections, setDdlSections] = useState([]);

  // Pagination states
  // const [currentPage, setCurrentPage] = useState(1);
  // const recordsPerPage = 10;

  useEffect(() => {

    const fetchLists = async () => {
      try {
        const [accountRes, SectionRes] = await Promise.all([
          axios.get(`${BASE_URL}/api/ddl_Accnt_Mast`),
          axios.get(`${BASE_URL}/api/ddl_sections`),
        ]);

        setAcctCodes(accountRes.data);
        setDdlSections(SectionRes.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchLists();

  }, []);

  const handleRunReport = async () => {

    try {

      if (!paramFromDate || paramFromDate === '') {
        toast.error('Please enter From Date.');
        return;
      } else if (!paramToDate || paramToDate === '') {
        toast.error('Please enter To Date.');
        return;
      } else if (paramFromDate > paramToDate) {
        toast.error('From Date cannot be grater than To Date.');
        return;
      } else if (!ddlSectionId || ddlSectionId === '') {
        toast.error('Please select Section.');
        return;
      }

      setLedgerData([]);
      setGroupedData([]);

      const ledgerRes = await axios.get(`${BASE_URL}/api/rpt_ledger`,
        { params: { p_Acct_Code: paramAcct_Code || 0, p_FromDate: paramFromDate, p_ToDate: paramToDate, 
                    p_Section_Id: ddlSectionId, p_ZeroBalLedger: paramZeroLed === 'ZERO' ? 0 : 1 } });

      if (ledgerRes.data.length > 0) {
        const grpData = groupDataOnAccntName(ledgerRes.data);
        setLedgerData(ledgerRes.data);
        setGroupedData(grpData);
        setSocietyName(ledgerRes.data[0].scty_name);
      } else {
        setGroupedData({});
        toast.error('No Record available');
      }

    } catch (error) {
     toast.error('Error Ledger : ', error);
   }
 
  };

  const groupDataOnAccntName = (completedata) => {
    return completedata.reduce((acc, result) => {
      const { acct_name } = result;
      if (!acc[acct_name]) {
        acc[acct_name] = [];
      }
      acc[acct_name].push(result);
      return acc;
    }, {});
  };

  function formatCurrency(amount) {

    const numberFormat = new Intl.NumberFormat('en-IN', {
      style: 'decimal', //'currency',
      minimumFractionDigits: 2,
      currency: 'INR',
      currencyDisplay: 'symbol',
    });

    return numberFormat.format(amount);

  }

  /// Export to Excel
  const handleDownloadExcel = () => {

    exportLedgerExcel({
      groupedData,
      fromDate: paramFromDate,
      toDate: paramToDate,
      societyName,
    });

  };

  /// download PDF
  const handleDownloadPDF = () => {

    exportLedgerPDF({
      groupedData,
      fromDate: paramFromDate,
      toDate: paramToDate,
      societyName: societyName,
    });

  };

  const options = acctCodes.map(code => ({
    value: String(code.acct_code),
    label: code.acct_name
  })) || [];

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <Card className="mb-3 p-2">

        <Row className="mt-3">
          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "80px" }}>Account</InputGroup.Text>
              <div style={{ flexGrow: 1 }}>
              <Select name="paramAcct_Code"
                    options={options}
                    value={options.find(option => option.value === paramAcct_Code) || null}
                    onChange={(selectedOption) => setParamAcct_Code(selectedOption?.value || "")}
                     className="w-100"
                    placeholder="-- Select Account --"
                  />
              </div>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>From Date</InputGroup.Text>
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramFromDate}
              onChange={(e) => setParamFromDate(e.target.value)}
            />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>To Date</InputGroup.Text>
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramToDate}
              onChange={(e) => setParamToDate(e.target.value)}
            />
            </InputGroup>
          </Col>

        </Row>

        <Row className="mt-3">
          <Col md={4}>
            <InputGroup >
              <InputGroup.Text>Section</InputGroup.Text>
              <select className="form-select" name="ddlSectionId" value={ddlSectionId}
                onChange={(e) => setDdlSectionId(e.target.value)} >
                <option value="">-- Select Section --</option>
                {ddlSections.map(sec => (
                  <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

        {/*    <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Ledger Type</InputGroup.Text>
              <Form.Select name="ledgerType" value={paramLedgerType} onChange={(e) => setParamLedgerType(e.target.value)} >
                <option value="G">GENERAL LEDGER</option>
                <option value="V">VENDOR LEDGER</option>
              </Form.Select>
            </InputGroup>
          </Col>
         */}
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Zero Balance</InputGroup.Text>
              <div className="d-flex align-items-center ms-3">
                <Form.Check type="radio" id="zeroValue" label="Include" name="paramZeroLed"
                  value="ZERO" checked={paramZeroLed === "ZERO"} onChange={(e) => setParamZeroLed(e.target.value)}
                  className="me-3"/>
                <Form.Check type="radio" id="nonZeroValue" label="Exclude" name="paramZeroLed"
                  value="NONZERO" checked={paramZeroLed === "NONZERO"}
                  onChange={(e) => setParamZeroLed(e.target.value)} />
              </div>
            </InputGroup>
          </Col>

          <Col md={5} className="d-flex justify-content-end">

            <Button style={{ height: '40px', width: '145' }} className="me-2" variant="secondary"
                    onClick={handleDownloadExcel} disabled={ledgerData.length === 0}>Download Excel</Button>

            <Button style={{ height: '40px', width: '135' }} className="me-2" variant="warning" 
                    onClick={handleDownloadPDF} disabled={ledgerData.length === 0}>Download PDF</Button>

            <Button style={{ height: '40px', width: '135' }} className="me-2" variant="success" 
                    onClick={handleRunReport} >Run Report</Button>
            
          </Col>

        </Row>

      </Card>

      {/* Details Table */}
      <Card className="p-3">
        <div style={{ minHeight: '380px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }}  className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>
                <th style={{ textAlign: 'center', width: '7%' }}>Vchr No</th>
                <th style={{ textAlign: 'center', width: '7%' }}>Date</th>
                <th style={{ textAlign: 'left', width: '12%' }}>Chq No.</th>
                <th style={{ textAlign: 'left', width: '24%' }}>Narration</th>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Debit Amount</th>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Credit Amount</th>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Closing Bal.</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupedData).map((acct_name) => (
                <React.Fragment key={acct_name}>
                  <tr style={{ border: '1px solid black' }}>
                    {/* , backgroundColor: '#f0f0f0'  */}
                    <td colSpan="7" style={{ fontWeight: 'bold', height: '5px' }}>
                      {acct_name}
                    </td>
                  </tr>
                  {groupedData[acct_name].map((result, index) => (
                    <tr key={index} style={{ height: '20px', border: '1px solid black', 
                        fontWeight: result.narration === 'Closing Balance' || result.narration === 'Opening Balance'  ? 'bold' : 'normal',
                        backgroundColor: result.narration === 'Closing Balance' ? '#f3f3f3' : 'white' }}>
                      <td style={{ textAlign: 'center'}}>{result.vchr_no}</td>
                      <td>{result.vchr_date}</td>
                      <td>{result.chq_no}</td>
                      <td style={{ width: '40px' }} className='wrap-text'>{result.narration}</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(result.dr_amt)}</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(result.cr_amt)}</td>
                      <td style={{ textAlign: 'right' }}>{result.close_bal} </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}

            </tbody>
          </table>
        </div>

      </Card>
    </Container>
  );
};

export default Ledger_Report;
